<div class="drawer-container">
  <div class="drawer-header">
    <div class="section-header-container">
      <h2 class="overline grey1 semibold section-title">{{helpAndFeedback.sysText.knowledgeBase_title}}</h2>
      <mat-divider class="section-header-underline"></mat-divider>
    </div>
    <button
      mat-icon-button
      color="accent"
      [attr.aria-label]="helpAndFeedback.sysText.close_ariaLabel"
      [disableRipple]="true"
      (click)="onCloseHelp()"
      class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <p class="body2">{{helpAndFeedback.sysText.knowledgeBase_subtitle}}</p>
  <div class="section-body-container">
    @for (link of helpAndFeedback.helpInfo.knowledgeBaseLinks; track link) {
      <p class="body2 knowledge-links">
        <a [href]="link.url" target="_blank">{{link.title}}@if (!(isMobile$ | async)) {
          <mat-icon>open_in_new</mat-icon>
        }</a>
      </p>
    }
  </div>

  @if (helpAndFeedback.helpInfo.resourceLinks?.length > 0) {
    <div>
      <div class="section-header-container">
        <h2 class="overline grey1 semibold section-title">{{helpAndFeedback.sysText.resources_title}}</h2>
        <mat-divider class="section-header-underline"></mat-divider>
      </div>
      <p class="body2">{{helpAndFeedback.sysText.resources_subtitle}}</p>
      <div class="section-body-container">
        @for (link of helpAndFeedback.helpInfo.resourceLinks; track link) {
          <p class="body2 knowledge-links">
            <a [href]="link.url" target="_blank">{{link.title}}@if (!(isMobile$ | async)) {
              <mat-icon>open_in_new</mat-icon>
            }</a>
          </p>
        }
      </div>
    </div>
  }

  <div class="section-header-container">
    <h2 class="overline grey1 semibold section-title">{{helpAndFeedback.sysText.contactLeaveAdmin_title}}</h2>
    <mat-divider class="section-header-underline"></mat-divider>
  </div>
  <p class="body2">{{helpAndFeedback.sysText.contactLeaveAdmin_subtitle}}</p>
  <div class="section-body-container">
    <div class="contact-admin-container">
      <div>
        <p class="overline admin-title">{{helpAndFeedback.sysText.helpFeedbackAdmin_title}}</p>
        @if (helpAndFeedback.helpInfo.helpAndFeedbackAdmin != null) {
          <div class="d-flex">
            @if (helpAndFeedback.helpInfo.helpAndFeedbackAdmin.image) {
              <img
                class="image-container"
                [src]="helpAndFeedback.helpInfo.helpAndFeedbackAdmin.image"
                alt="">
            }
            @if (!helpAndFeedback.helpInfo.helpAndFeedbackAdmin.image) {
              <div class="circle">
                {{ getInitials(helpAndFeedback.helpInfo.helpAndFeedbackAdmin.description) }}
              </div>
            }
            <div class="employee-info">
              <p class="grey1 body2 bold">{{ helpAndFeedback.helpInfo.helpAndFeedbackAdmin.description }}</p>
              <p class="grey2 caption">{{ helpAndFeedback.helpInfo.helpAndFeedbackAdmin.workEmail }}</p>
              <p class="grey2 caption">{{ helpAndFeedback.helpInfo.helpAndFeedbackAdmin.formattedWorkPhone }}</p>
            </div>
          </div>
        } @else {
          <div class="d-flex">
            <img
              [src]="'assets/images/missing_avatar.svg'"
              alt=""
              class="image-container" />
            <div class="employee-info">
              <p class="grey1 body2">{{helpAndFeedback.sysText.noAdminAvailable}}</p>
            </div>
          </div>
        }
      </div>
      <span>
        @if (!(isMobile$ | async) && helpAndFeedback.helpInfo.helpAndFeedbackAdmin != null) {
          <button
            (click)="contactAdmin(helpAndFeedback.helpInfo.helpAndFeedbackAdmin)"
            mat-flat-button
            color="accent"
            class="button">
            {{helpAndFeedback.sysText.contact}}
          </button>
        }
        @if (isMobile$ | async) {
          <button
            mat-icon-button
            [attr.aria-label]="helpAndFeedback.sysText.contact"
            (click)="contactAdmin(helpAndFeedback.helpInfo.helpAndFeedbackAdmin)"
            color="accent"
            class="button">
            <mat-icon>mail</mat-icon>
          </button>
        }
      </span>
    </div>

    @if (helpAndFeedback.helpInfo.leaveAdmins?.length > 0) {
      <div>
        @for (admin of helpAndFeedback.helpInfo.leaveAdmins; track admin) {
          <div class="contact-admin-container">
            <div>
              <p class="overline admin-title">{{helpAndFeedback.sysText.assignedAdmin_title}}</p>
              @if (admin != null) {
                <div class="d-flex">
                  @if (admin.image) {
                    <img
                      class="image-container"
                      [src]="admin.image"
                      alt="">
                  }
                  @if (!admin.image) {
                    <div class="circle">
                      {{ getInitials(admin.description) }}
                    </div>
                  }
                  <div class="employee-info">
                    <p class="grey1 body2 bold">{{ admin.description }}</p>
                    <p class="grey2 caption">{{ admin.workEmail }}</p>
                    <p class="grey2 caption">{{ admin.formattedWorkPhone }}</p>
                  </div>
                </div>
              } @else {
                <div class="d-flex">
                  <img
                    [src]="'assets/images/missing_avatar.svg'"
                    alt=""
                    class="image-container" />
                  <div class="employee-info">
                    <p class="grey1 body2">{{helpAndFeedback.sysText.noAdminAvailable}}</p>
                  </div>
                </div>
              }
            </div>
            <span>
              @if (!(isMobile$ | async)) {
                <button
                  (click)="contactAdmin(admin)"
                  mat-flat-button
                  color="accent"
                  class="button">
                  {{helpAndFeedback.sysText.contact}}
                </button>
              }
              @if (isMobile$ | async) {
                <button
                  mat-icon-button
                  [attr.aria-label]="helpAndFeedback.sysText.contact"
                  (click)="contactAdmin(admin)"
                  color="accent"
                  class="button">
                  <mat-icon>mail</mat-icon>
                </button>
              }
            </span>
          </div>
        }
      </div>
    }

  </div>

  @if (helpAndFeedback.helpInfo.canContactSupport) {
    <div>
      <div class="section-header-container">
        <h2 class="overline grey1 semibold section-title">{{helpAndFeedback.sysText.contactStiiraSupport_title}}</h2>
        <mat-divider class="section-header-underline"></mat-divider>
      </div>
      <p class="body2">{{helpAndFeedback.sysText.contactStiiraSupport_subtitle}}</p>
      <div class="section-body-container">
        <a
          mat-flat-button
          color="accent"
          class="button"
          [href]="helpAndFeedback.helpInfo.contactSupportUrl"
          target="_blank">
          {{helpAndFeedback.sysText.contactStiiraSupport_button}}
        </a>
      </div>
    </div>
  }

  <div class="section-header-container">
    <h2 class="overline grey1 semibold section-title">{{helpAndFeedback.sysText.submitFeedback_title}}</h2>
    <mat-divider class="section-header-underline"></mat-divider>
  </div>
  <p class="body2">{{helpAndFeedback.sysText.submitFeedback_subtitle}}</p>
  <div class="section-body-container">
    <a
      mat-flat-button
      color="accent"
      class="button"
      [href]="helpAndFeedback.helpInfo.submitFeedbackUrl"
      target="_blank">
      {{helpAndFeedback.sysText.submitFeedback_button}}
    </a>
  </div>
</div>
